import SubmitProposals from './SubmitProposalsContainer';
export default SubmitProposals;